import { useCallback, useEffect, useRef } from "react";
import { trackEventWithDigitalData } from "./digitalData";

const useDigitalDataTracking = (
  data_page_name,
  data_siteSection,
  eventName,
  hitType,
  eventData = {},
  retry = false
) => {
  const metaData = {
    data_page_name,
    data_siteSection,
  };

  const memoizedResult = useRef();

  if (!memoizedResult.current || memoizedResult.current?.retry !== retry) {
    memoizedResult.current = {
      metaData,
      eventName,
      hitType,
      eventData,
      retry,
    };
  }

  const trackDigitalDataEvent = useCallback(() => {
    try {
      trackEventWithDigitalData(memoizedResult.current);
    } catch (error) {
      console.error("Error occurred while tracking digital data event:", error);
      // You can add error handling or reporting logic here
    }
  }, []);

  useEffect(() => {
    trackDigitalDataEvent();
  }, [retry, trackDigitalDataEvent]);

  return null;
};

export default useDigitalDataTracking;
